import * as React from "react";
import clsx from "clsx";
import * as s from "../../FormInput.style.css";
import type { TextInputProps } from "./TextInput.types";

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput({ label, error, changed, id, className, ...rest }, ref) {
    const inputId = id ?? React.useId();
    return (
      <div className={s.wrapper}>
        {label && (
          <label htmlFor={inputId} className={s.label}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          type="text"
          id={inputId}
          className={clsx(s.input, changed && s.inputChanged, error && s.inputError, className)}
          aria-invalid={!!error}
          aria-describedby={error ? `${inputId}-error` : undefined}
          {...rest}
        />
        {error && (
          <span id={`${inputId}-error`} className={s.errorText} role="alert">
            {error}
          </span>
        )}
      </div>
    );
  }
);
